import script from "./Presidential.vue?vue&type=script&setup=true&lang=js"
export * from "./Presidential.vue?vue&type=script&setup=true&lang=js"

import "./Presidential.vue?vue&type=style&index=0&id=1543ca1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1543ca1e"]])

export default __exports__